// Formats whole dollars, with negatives in parentheses (-10133 -> "($10,133)").
export const formatAccountingCurrency = (value: number | null | undefined): string => {
    if (value == null) return '';

    const text = Math.abs(value).toLocaleString('en-US', {
        style: 'currency',
        currency: 'USD',
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
    });
    return Math.round(value) < 0 ? `(${text})` : text;
};
